export default {"src":"/_next/static/media/wollongong.f5c473e5.svg","height":191,"width":332,"blurWidth":0,"blurHeight":0};